export default function shopReducer(shopState = "") {
	return shopState;
}
